// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Log$SmartcutsMacros = require("../Log.bs.js");
var Util$SmartcutsMacros = require("../../../bs-utils/src/Util.bs.js");
var Query$SmartcutsMacros = require("../../../bs-select/src/Query.bs.js");
var Exceptions$SmartcutsMacros = require("../Exceptions.bs.js");
var OptionUtils$SmartcutsMacros = require("../../../bs-utils/src/OptionUtils.bs.js");
var PromiseUtils$SmartcutsMacros = require("../../../bs-utils/src/PromiseUtils.bs.js");
var DevProtocol__DOM$SmartcutsMacros = require("./DevProtocol__DOM.bs.js");
var QueryInBackground$SmartcutsMacros = require("../QueryInBackground.bs.js");
var Selector__Background$SmartcutsMacros = require("../Selector__Background.bs.js");

function waitForElementInBackgroundViaSearch(timeout, interval, maybeQueryRoot, useInnerText, maybeInnerTextSemantic, tabId, domTree, includeElementsNotVisibleOpt, selector) {
  var includeElementsNotVisible = includeElementsNotVisibleOpt !== undefined ? includeElementsNotVisibleOpt : false;
  var queryRoot = maybeQueryRoot !== undefined ? maybeQueryRoot : /* Document */0;
  return Util$SmartcutsMacros.waitForPromise2(timeout, interval, (function (addOnPredicateTimedOutCallback) {
                  return Curry.app(QueryInBackground$SmartcutsMacros.search1, [
                                useInnerText,
                                maybeInnerTextSemantic,
                                {
                                  tabId: tabId
                                },
                                queryRoot,
                                selector,
                                addOnPredicateTimedOutCallback,
                                domTree,
                                undefined,
                                includeElementsNotVisible,
                                undefined
                              ]).then(function (result_maybeNodeIdAndBackendNodeId) {
                              if (result_maybeNodeIdAndBackendNodeId.TAG !== /* Ok */0) {
                                return Promise.resolve({
                                            TAG: /* ErrorDuringPredicate */2,
                                            _0: result_maybeNodeIdAndBackendNodeId._0
                                          });
                              }
                              var nodeIdAndBackendNodeId = result_maybeNodeIdAndBackendNodeId._0;
                              if (nodeIdAndBackendNodeId !== undefined) {
                                return Promise.resolve({
                                            TAG: /* PredicateSatisfied */0,
                                            _0: nodeIdAndBackendNodeId
                                          });
                              } else {
                                return Promise.resolve(/* PredicateNotSatisfied */0);
                              }
                            });
                })).then(function (result) {
              if (result.TAG === /* Ok */0) {
                var nodeIdAndBackendNodeId = result._0;
                switch (nodeIdAndBackendNodeId.TAG | 0) {
                  case /* PredicateDidResolveTo */0 :
                      return Promise.resolve({
                                  TAG: /* Ok */0,
                                  _0: nodeIdAndBackendNodeId._0
                                });
                  case /* TimedOut */1 :
                  case /* PredicateTimedOut */2 :
                      break;
                  
                }
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: {
                              TAG: /* SearchElementTimedOut */7,
                              _0: {
                                selector: selector,
                                ms: nodeIdAndBackendNodeId._0
                              }
                            }
                          });
              }
              var jsPromiseError = result._0;
              if (jsPromiseError.TAG === /* UncaughtPredicateError */0) {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: {
                              TAG: /* ErrorWhileSearchForElement */9,
                              _0: jsPromiseError._0
                            }
                          });
              } else {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: jsPromiseError._0
                          });
              }
            });
}

function waitForElementInForegroundViaSearch(timeout, interval, maybeQueryRoot, useInnerText, maybeInnerTextSemantic, onlyConsiderElementChainIf, includeElementsNotVisibleOpt, selector) {
  var includeElementsNotVisible = includeElementsNotVisibleOpt !== undefined ? includeElementsNotVisibleOpt : false;
  var queryRoot = OptionUtils$SmartcutsMacros.withDefault(/* Document */0, maybeQueryRoot);
  return Util$SmartcutsMacros.waitForPromise2(timeout, interval, (function (addOnPredicateTimedOutCallback) {
                  return Query$SmartcutsMacros.QueryInWebPage.searchWithScrolling(useInnerText, maybeInnerTextSemantic, /* Not_Used */0, queryRoot, selector, addOnPredicateTimedOutCallback, undefined, onlyConsiderElementChainIf, includeElementsNotVisible, undefined).then(function (result_maybeDomElement) {
                              if (result_maybeDomElement.TAG !== /* Ok */0) {
                                return Promise.resolve({
                                            TAG: /* ErrorDuringPredicate */2,
                                            _0: undefined
                                          });
                              }
                              var domElement = result_maybeDomElement._0;
                              if (domElement !== undefined) {
                                return Promise.resolve({
                                            TAG: /* PredicateSatisfied */0,
                                            _0: Caml_option.valFromOption(domElement)
                                          });
                              } else {
                                return Promise.resolve(/* PredicateNotSatisfied */0);
                              }
                            });
                })).then(function (result) {
              if (result.TAG === /* Ok */0) {
                var domElement = result._0;
                switch (domElement.TAG | 0) {
                  case /* PredicateDidResolveTo */0 :
                      return Promise.resolve({
                                  TAG: /* Ok */0,
                                  _0: domElement._0
                                });
                  case /* TimedOut */1 :
                  case /* PredicateTimedOut */2 :
                      break;
                  
                }
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: {
                              TAG: /* SearchElementTimedOut */7,
                              _0: {
                                selector: selector,
                                ms: domElement._0
                              }
                            }
                          });
              }
              var jsPromiseError = result._0;
              if (jsPromiseError.TAG === /* UncaughtPredicateError */0) {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: {
                              TAG: /* ErrorWhileSearchForElement */9,
                              _0: jsPromiseError._0
                            }
                          });
              } else {
                return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected: OtherError not expected");
              }
            });
}

function waitForElementInBackgroundViaQuerySelector(timeout, interval, queryRoot, tabId, querySelectorStr) {
  return Util$SmartcutsMacros.waitForPromise2(timeout, interval, (function (addOnPredicateTimedOutCallback) {
                  var match = PromiseUtils$SmartcutsMacros.withRetries(3, (function (addCancelCallback, param) {
                          var tmp;
                          if (typeof queryRoot === "number") {
                            var match = PromiseUtils$SmartcutsMacros.makeCancelable(function (param, isCanceled) {
                                  if (isCanceled.contents) {
                                    throw {
                                          RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                                          Error: new Error()
                                        };
                                  }
                                  return DevProtocol__DOM$SmartcutsMacros.getDocument(undefined, true, tabId, undefined, undefined, undefined).then(function ($$document) {
                                              Curry._2(Log$SmartcutsMacros.playback.log2, "DOCUMENT", $$document);
                                              if ($$document === undefined) {
                                                return Promise.resolve({
                                                            TAG: /* Error */1,
                                                            _0: /* CdpUnableToGetDocument */1
                                                          });
                                              }
                                              var rootNode = Caml_option.valFromOption($$document);
                                              return Promise.resolve({
                                                          TAG: /* Ok */0,
                                                          _0: [
                                                            rootNode.nodeId,
                                                            rootNode.backendNodeId
                                                          ]
                                                        });
                                            });
                                });
                            Curry._1(addCancelCallback, match[1]);
                            tmp = Curry._1(match[0], undefined);
                          } else {
                            var match$1 = queryRoot._0;
                            tmp = Promise.resolve({
                                  TAG: /* Ok */0,
                                  _0: [
                                    match$1[0],
                                    match$1[1]
                                  ]
                                });
                          }
                          return tmp.then(function (result_element) {
                                        if (result_element.TAG !== /* Ok */0) {
                                          return Promise.resolve({
                                                      TAG: /* Error */1,
                                                      _0: result_element._0
                                                    });
                                        }
                                        var rootNodeId = result_element._0[0];
                                        var match = PromiseUtils$SmartcutsMacros.makeCancelable(function (param, isCanceled) {
                                              if (isCanceled.contents) {
                                                throw {
                                                      RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                                                      Error: new Error()
                                                    };
                                              }
                                              return DevProtocol__DOM$SmartcutsMacros.querySelectorAll(rootNodeId, querySelectorStr, tabId, undefined, undefined, undefined);
                                            });
                                        Curry._1(addCancelCallback, match[1]);
                                        return PromiseUtils$SmartcutsMacros.map(Curry._1(match[0], undefined), (function (results) {
                                                      return {
                                                              TAG: /* Ok */0,
                                                              _0: results
                                                            };
                                                    }));
                                      }).then(function (result_results) {
                                      if (result_results.TAG !== /* Ok */0) {
                                        return Promise.resolve({
                                                    TAG: /* ErrorDuringPredicate */2,
                                                    _0: result_results._0
                                                  });
                                      }
                                      var nodeId = Belt_Array.get(result_results._0, 0);
                                      if (nodeId !== undefined) {
                                        return Promise.resolve({
                                                    TAG: /* PredicateSatisfied */0,
                                                    _0: nodeId
                                                  });
                                      } else {
                                        Curry._2(Log$SmartcutsMacros.dom.log2, "Failed waitForElementInBackgroundViaQuerySelector", querySelectorStr);
                                        return Promise.resolve(/* PredicateNotSatisfied */0);
                                      }
                                    });
                        }), (function (param) {
                          return Selector__Background$SmartcutsMacros.shouldRetryForJsPromiseError(queryRoot, param);
                        }), /* PredicateNotSatisfied */0, undefined);
                  Curry._1(addOnPredicateTimedOutCallback, match[1]);
                  return Curry._1(match[0], undefined);
                })).then(function (result) {
              if (result.TAG === /* Ok */0) {
                var nodeIdAndBackendNodeId = result._0;
                switch (nodeIdAndBackendNodeId.TAG | 0) {
                  case /* PredicateDidResolveTo */0 :
                      return Promise.resolve({
                                  TAG: /* Ok */0,
                                  _0: nodeIdAndBackendNodeId._0
                                });
                  case /* TimedOut */1 :
                  case /* PredicateTimedOut */2 :
                      break;
                  
                }
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: {
                              TAG: /* CdpQuerySelectorTimedOut */10,
                              _0: {
                                querySelector: querySelectorStr,
                                ms: nodeIdAndBackendNodeId._0
                              }
                            }
                          });
              }
              var jsPromiseError = result._0;
              if (jsPromiseError.TAG === /* UncaughtPredicateError */0) {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: {
                              TAG: /* ErrorWhileCdpQuerySelector */11,
                              _0: jsPromiseError._0
                            }
                          });
              } else {
                return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected: OtherError not expected");
              }
            });
}

exports.waitForElementInBackgroundViaSearch = waitForElementInBackgroundViaSearch;
exports.waitForElementInForegroundViaSearch = waitForElementInForegroundViaSearch;
exports.waitForElementInBackgroundViaQuerySelector = waitForElementInBackgroundViaQuerySelector;
/* Log-SmartcutsMacros Not a pure module */
